export function normalizeMoney(input) {
  if (input == null) return ""

  let s = String(input).trim()

  s = s.replace(",", ".")

  if (!/^\d*\.?\d*$/.test(s)) return ""

  if (s === "" || s === ".") return ""

  if (s.startsWith(".")) s = "0" + s

  const num = Number(s)

  if (!Number.isFinite(num) || num < 0) return ""

  const truncated = Math.trunc(num * 100) / 100

  return truncated.toFixed(2)
}
